export type HeroParticle = {
  size: number;
  top: string;
  left: string;
  color: string;
  duration: string;
  delay: string;
  scaleMid: string;
  scaleLow: string;
};

const PARTICLE_COLORS = ["96, 172, 255", "150, 130, 255", "63, 170, 255", "178, 141, 255"];

const randomBetween = (min: number, max: number) => min + Math.random() * (max - min);

export const createHeroParticles = (count = 7): HeroParticle[] =>
  Array.from({ length: count }, () => ({
    size: Math.round(randomBetween(120, 320)),
    top: `${randomBetween(-10, 90).toFixed(1)}%`,
    left: `${randomBetween(-5, 95).toFixed(1)}%`,
    color: `rgba(${PARTICLE_COLORS[Math.floor(Math.random() * PARTICLE_COLORS.length)]}, ${randomBetween(0.16, 0.34).toFixed(2)})`,
    duration: `${randomBetween(16, 34).toFixed(1)}s`,
    delay: `-${randomBetween(0, 20).toFixed(1)}s`,
    scaleMid: randomBetween(1.04, 1.3).toFixed(2),
    scaleLow: randomBetween(0.72, 0.96).toFixed(2),
  }));
